import React from 'react';
import { FormInputContainerComponent, ItemComponent } from './InputWrappersComponent';

export class LegendFieldComponent extends React.Component {
    render() {
        const { children, classNameInputContainer } = this.props;
        return (
            <FormInputContainerComponent
                className={`form-input-legend ${
                    classNameInputContainer ? classNameInputContainer : ''
                }`}>
                <ItemComponent className="item item-legend">{children}</ItemComponent>
            </FormInputContainerComponent>
        );
    }
}

export default LegendFieldComponent;



// WEBPACK FOOTER //
// ./src/components/form/LegendFieldComponent.js